{
  "alerts": {
    "cantCreateProperty": "Błąd, nie udało zaktualizować informacji o mieszkaniu. Spróbuj ponownie później.",
    "cantCreateUser": "Błąd, nie udało się stworzyć użytkownika. Spróbuj ponownie później.",
    "cantCancelReservation": "Błąd, nie udało się odwołać rezerwacji. Spróbuj ponownie później.",
    "cantCancelSubscription": "Błąd, nie udało się odwołać subskrypcji. Spróbuj ponownie później.",
    "cantUpdate": "Błąd, nie udało się zaktualizować informacji. Spróbuj ponownie później.",
    "cantUpdateReservtion": "Błąd, nie udało się zaktualizować rezerwacji. Spróbuj ponownie później lub napisz do nas.",
    "emailIsIncorrect": "Adres e-mail jest nieprawidłowy. Upewnij się, że wprowadzony adres jest poprawnie napisany",
    "googlePlayServicesNotAvailable": "Google Play Services nie są dostępne na Twoim urządzeniu.",
    "locationNotEnabledDescription": "Musisz włączyć lokalizację, aby mieć możliwość realizacji zleceń",
    "locationNotEnabledTitle": "Włącz lokalizację",
    "mandatoryUpdateMessage": "Dostępna jest aktualizacja która musi zostać zainstalowana.",
    "outdatedPaymentMethod": "Wybrana metoda płatności jest nieaktualna. Zaktualizuj metodę płatności i spróbuj ponownie.",
    "paymentFailed": "Wystąpił błąd podczas płatności.\nSkontaktuj się z supportem bądź spróbuj ponownie",
    "sthWentWrong": "Błąd, coś poszło nie tak.\nSkontaktuj się z supportem bądź spróbuj ponownie",
    "unavailableLocalization": "Twoja lokalizacja nie jest jeszcze dostępna",
    "update": "Aktualizuj",
    "updateTitle": "Dostępna aktualizacja",
    "userWithEmailAlreadyExists": "Użytkownik o tym adresie e-mail już istnieje"
  },
  "common": {
    "accept": "Akceptuj",
    "add": "Dodaj",
    "added": "Dodane",
    "at": "o",
    "cancel": "Anuluj",
    "chat": "Czat",
    "change": "Zmień",
    "choose": "Wybierz",
    "choosePhoto": "Wybierz zdjęcie",
    "chosen": "Wybrano",
    "clear": "Wyczyść",
    "close": "Zamknij",
    "closePage": "Zamknij stronę",
    "continue": "Dalej",
    "date": "Data",
    "default": "Domyślna",
    "delete": "Usuń",
    "deleteService": "Usuń %{service}",
    "details": "szczegóły",
    "discount": "Zniżka",
    "done": "Gotowe",
    "edit": "Edytuj",
    "error": "Błąd",
    "email": "Email",
    "from": "Od",
    "goBack": "Wróć",
    "help": "Pomoc",
    "hi": "Cześć! 👋",
    "hours": "godz.",
    "id": "ID",
    "menu": "Menu",
    "name": "Imię",
    "no": "Nie",
    "OK": "OK",
    "or": "Lub",
    "order": "Zamówienie",
    "phone": "Numer telefonu",
    "popular": "Polecane",
    "price": "Cena",
    "return": "Powrót",
    "save": "Zapisz",
    "service": "Usługa",
    "skip": "Pomiń",
    "stripe": "Stripe",
    "takePhoto": "Zrób zdjęcie",
    "time": "Czas",
    "together": "Razem",
    "tryAgain": "Spróbuj ponownie",
    "understand": "Rozumiem",
    "update": "Zaktualizuj",
    "whether": "Czy",
    "yes": "Tak"
  },
  "components": {
    "drawer": {
      "aboutStepapp": "O Stepapp",
      "coupons": "Kupony",
      "covid19": "Nasza reakcja na Covid-19",
      "covid19Response": "Odpowiedź na Covid-19",
      "downloadApp": "Pobierz aplikacje",
      "help": "Pomoc",
      "hey": "Hej! ",
      "heyYou": "Hej %{name}!",
      "payments": "Metody płatności",
      "referAFriend": "Zaproś Znajomych",
      "settings": "Ustawienia",
      "showProfile": "Zobacz profil",
      "support": "Wsparcie",
      "writeToUs": "Napisz Do Nas"
    },
    "footer": {
      "about": "O nas",
      "app": "Aplikacja",
      "blog": "Blog",
      "cancellationRules": "Zasady Anulowania",
      "cleaningPersonnel": "Osoby sprzątające",
      "contact": "Skontaktuj się",
      "contactHours": "Pon-Sob 9:30-18:00",
      "cookies": "Korzystamy z ciasteczek, dzięki którym nasza strona działa poprawnie.",
      "daysAgo": "dni temu",
      "disclaimerPL": "Stepapp to Stepapp sp. z.o.o. zarejestrowana w Warszawie. Wpisana do Krajowego Rejestru Sądowniczego pod numerem 0000896336. NIP: 5252860294.",
      "disclaimerNO": "Stephome AS zarejestrowana w Oslo",
      "FAQ": "Pytania i odpowiedzi",
      "learnMore": "Dowiedz się więcej",
      "myths": "Mity dotyczące sprzątania",
      "privacyPolicy": "Polityka Prywatności",
      "reviews": "Opinie o Stepapp",
      "safePayment": "Bezpieczna płatność",
      "termsOfUse": "Zasady Korzystania",
      "today": "dzisiaj",
      "workers": "Osoby sprzątające",
      "worthKnowing": "Warto Znać",
      "yesterday": "wczoraj"
    },
    "header": {
      "aboutStepapp": "O Stepapp",
      "coupons": "Kupony",
      "help": "Pomoc",
      "inviteFriends": "Zaproś Znajomych",
      "payments": "Metody płatności",
      "profile": "Profil",
      "register": "Rejestracja",
      "services": "Usługi",
      "settings": "Ustawienia",
      "showProfile": "Zobacz profil",
      "signIn": "Zaloguj się",
      "support": "Wsparcie",
      "writeToUs": "Napisz Do Nas"
    },
    "input": {
      "placeholder": {
        "additionalInstructions": "Przykład: Proszę zapukać do drzwi zamiast używać dzwonka.",
        "addNote": "Dodaj notatkę (opcjonalnie)",
        "addressFirstLine": "Adres 1. linia",
        "addressSecond": "Druga linia adresu",
        "addressSecondLine": "Adres 2. linia",
        "apartmentNumber": "Numer mieszkania",
        "city": "Miasto",
        "companyName": "Nazwa firmy",
        "doorCode": "Kod do bramki",
        "email": "Email",
        "firstName": "Twoje Imię",
        "homeDescription": "Np. na co zwrócić uwagę przy\nsprzątaniu?",
        "housing": "Osiedle",
        "keyInfo": "Gdzie zostawisz klucz? Np. “Klucz będzie pod fioletową doniczka, po lewej od drzwi“",
        "lastName": "Twoje Nazwisko",
        "NIPNumber": "Numer NIP",
        "postalCode": "Kod pocztowy",
        "propertyName": "Nazwa domu",
        "size": "Powierzchnia",
        "street": "Ulica",
        "typeAddress": "Wpisz adres"
      }
    },
    "houseAreaOutOfScope": {
      "houseAreaIsTooLarge": "Wprowadzona powierzchnia domu jest za duża.",
      "orderForLargerHouseArea": "Chesz zamówić sprzątanie dla większego metrażu? Napisz do nas!",
      "writeAndOrderCustomCleaning": "Chcę zamówić niestandardowe sprzątanie"
    },
    "paymentOptions": {
      "type_apple": "Apple Pay",
      "type_google": "Google Pay"
    },
    "shareCouponSheet": {
      "copy": "Kopiuj",
      "description": "Uzyskaj %{providerReward} za samą rejestrację\nznajomego, który zamówi pierwszą\nusługę. Za samą rejestracją dostanie %{receiverReward}\nod Ciebie!",
      "discountExplanation": "Minimalna wartość zamówienia - 100 zł.",
      "share": "Udostępnij",
      "shareMessage": "Przesyłam ci %{codeValue} zniżki na Twoje pierwsze sprzątanie w aplikacji Stepapp. Aby skorzystać, wpisz kod %{referralCode} podczas składania zamówienia!\nLink do złożenia zamówienia: %{appUrl}",
      "title": "Dobrzy Przyjaciele Dają Stepapp"
    },
    "tabBar": {
      "application": "Aplikacja",
      "calendar": "Kalendarz",
      "dashboard": "Zamów",
      "myHome": "Moje adresy",
      "openApp": "Otwórz aplikacje",
      "stepappApp": "Aplikacja Stepapp",
      "stepappAppDescription": "Pobierz naszą apkę mobilna, aby być na bieżąco ze swoimi zamówieniami i nie przegapić promocji oraz wiadomości od naszej obsługi!",
      "stepappMobileApp": "Aplikacja \nmobilna stepapp"
    },
    "tabBar_Calendar": "Kalendarz",
    "tabBar_Dashboard": "Zamów",
    "tabBar_MyHome": "Moje adresy"
  },
  "dialogs": {
    "couponActivated": "Kod promocyjny został aktywowany",
    "couponAdded": "Doładowano portfel Stepapp kwotą %{amount}",
    "couponCreditsAdded": "Twój portfel został doładowany o nowe kredyty do wykorzstania w aplikacji Stepapp.",
    "couponFindOtherAndTryAgain": "Lub jest niepoprawny. Sprawdź czy nie ma literówek i spróbuj wprowadzić go ponownie.",
    "couponInvalid": "Kod \"%{coupon}\" niepoprawny lub nieaktualny",
    "couponUsed": "Kod został już wykorzystany",
    "later": "Później",
    "multiPersonServiceInfoMessage": "Pamiętaj, że jedna rezerwacja przypisana jest do jednego wykonawcy usługi. Jeśli rezerwujesz usługę dla więcej niż 1 osoby, ta sama osoba zajmie się usługą jedna po drugiej. Jeśli chcesz zamówić usługę dla 2 osób w tym samym czasie, musisz złożyć 2 oddzielne zamówienia i wspomnieć o tym w notatkach do zamówienia.",
    "multiPersonServiceInfoTitle": "Informacja o usługach powyżej 1 osoby",
    "negativeRateTitle": "Napisz nam koniecznie, co\nmożemy zmienić lub poprawić. To\nbardzo nam pomoże!",
    "ofCourse": "Oczywiście",
    "positiveRateTitle": "Ekstra! 🤘 Prosimy, oceń naszą\naplikację. Będziemy bardzo\nwdzięczni!",
    "rateTitle": "Czy podoba Ci się\naplikacja Stepapp?"
  },
  "notifications": {
    "accountDeletion": {
      "description": "Rozpoczęto procedurę usuwania Twojego konta. Może to potrwać do 7 dni.",
      "title": "Konto w trakcie usuwania"
    },
    "permissionDenied": {
      "camera": "Nie masz uprawnień do kamery.",
      "cameraDescription": "Przejdź do ustawień aplikacji aby zezwolić na używanie kamery.",
      "notifications": "Włącz powiadomienia w Ustawieniach aplikacji",
      "notificationsDescription": "Używamy powiadomień, aby dostarczać Ci na bieżąco aktualizacje związane ze zleceniami. Bez ich włączenia, aplikacja może nie działać poprawnie."
    }
  },
  "pages": {
    "auth": {
      "basicInfoDescription": "Prosimy Cię tylko o potrzebne dane.\nTwoj adres e-mail i nazwisko bedzie widoczny tylko dla nas.",
      "registerInStepapp": "Zarejestruj się w Stepapp."
    },
    "chooseCard": {
      "addCard": "Dodaj kartę",
      "addCardFailed": "Dodanie karty nie powiodło się",
      "addCardFailedDescription": "Sprawdź podane dane lub spróbuj ponownie później",
      "cardRecurringPaymentsInfo": "Twoja karta zostanie przypisana do Twojego konta Stepapp i użyta do cyklicznych pobrań w subskrypcji. Zawsze możeszą ją zmienić w ustawieniach.",
      "cardNotSupportThisPayment": "Twoja karta nie wspiera tego typu płatności. Spróbuj dodać inną kartę.",
      "chooseCard": "Wybierz kartę",
      "confirm": "Zatwierdź",
      "newCard": "Nowa karta"
    },
    "serviceDateAndAddress": {
      "addAddress": "Dodaj adres",
      "addAddressDescription_cleaning": "Podaj szczegółowe informacje, abyśmy mogli rozpocząć sprzątanie bez przeszkód.",
      "addAddressDescription_massage": "Podaj szczegółowe informacje, abyśmy mogli rozpocząć masaż bez przeszkód.",
      "addAddressDescription_other": "Podaj szczegółowe informacje, abyśmy mogli rozpocząć usługę bez przeszkód.",
      "addressForm": {
        "address": "Ulica i numer domu",
        "addressSecond": "Druga linia adresu",
        "city": "Miasto",
        "doorCode": "Kod do bramki",
        "iWillBeThere": "Będę na miejscu",
        "iWillLeaveTheKey": "Zostawię klucz",
        "numberOrHousing": "Numer mieszkania",
        "postalCode": "Kod pocztowy"
      },
      "chooseHour": "Wybierz godzinę",
      "continueLabel": "Dalej - Podsumowanie i płatność",
      "description": "Wybierz datę i godzinę rozpoczęcia usługi",
      "howAreWeGoingToEnter": "Jak dostaniemy się do Twojego mieszkania?",
      "howAreWeGoingToEnterDescription": "To opcjonalna informacja, która pomoże nam bez przeszkód wykonać sprzątanie. Zawsze możesz dodać to później.",
      "instructionsForArrival": "Instrukcje dotarcia",
      "iWillBeThere": "Będę na miejscu",
      "iWillLeaveTheKey": "Zostawię klucz",
      "provideAddress": "Wprowadź adres",
      "provideAddressTitle": "Wprowadź adres realizacji usługi",
      "provideAddressToCheckAvailability": "Dzięki adresowi będziemy w stanie określić dostępność naszych usług",
      "title": "Kiedy zaczynamy?"
    },
    "serviceSummary": {
      "addCard": "Dodaj kartę",
      "additionalServices": "Dodatkowe usługi",
      "address": "Adres",
      "cancellationRules": "Zasady Anulowania",
      "cancellationRulesDescription": "Anuluj rezerwację przed %{date}, aby uniknąć dodatkowych opłat. Anulowanie po tym czasie będzie wiązało się z dodatkowymi opłatami do 50% wartości zamówienia.",
      "cardDescription": "Zablokujemy środki dopiero 48 godzin przed sprzątaniem. Samo pobranie nastąpi jednak dopiero w dniu sprzątania.",
      "couponList": "Lista kuponów",
      "dateNotAvailable": "Wybrana przez Ciebie data jest już niedostępna. Wróć do kalendarza i wbierz nową datę sprzątania.",
      "description": "Przejrzyj swoje zamówienie jeszcze raz i sprawdź, czy wszystko się zgadza",
      "doYouNeedVATInvoice": "Potrzebujesz faktury VAT?",
      "enterCoupon": "Wprowadź kupon",
      "haveCoupon": "Masz kupon?",
      "haveCouponDescription": "Kupon możesz dodać po zalogowaniu lub rejestracji.",
      "howAreWeGoingToEnter": "Jak dostaniemy się do Twojego mieszkania?",
      "instantPaymentCardDescription": "Całą kwotę pobierzemy od razu po złożeniu zamówienia, z uwagi na To, że do Twojego zamówienia pozostało mniej niż 48 godzin.",
      "instantPaymentInfo": "Środki z Twojej karty zostaną pobrane natychmiastowo, ponieważ do rozpoczęcia usługi zostało mniej niż 48 godzin.",
      "instantPaymentRules": "Twoja rezerwacja rozpocznie się wcześniej, niż za 48 godzin. Anulowanie po tym czasie będzie wiązało się z dodatkowymi opłatami do 50% wartości zamówienia.",
      "invoiceAdditionalEmail": "Możesz tu dodać dodatkowy adres mailowy do wysyłki faktury. Jeśli pozostawisz pole puste, fakturę wyślemy na adres email Twojego konta.",
      "invoiceBeforeSubmit": "Możesz to zrobić jedynie przed złożeniem zamówienia.",
      "loginToViewDetails": "Zaloguj się lub zarejestruj, aby złożyć zamówienie",
      "nextSteps": "Następne kroki",
      "nextStepsDescription_cleaning": "Po złożeniu rezerwacji, przypiszemy jedną z naszych wspaniałych pań sprzątających, dostępna w Twojej okolicy. Poznasz ją w aplikacji przed rozpoczęciem sprzątania.",
      "nextStepsDescription_massage": "Po złożeniu rezerwacji, przypiszemy jednego z naszych masażystów, dostępnego w Twojej okolicy. Poznasz go w aplikacji przed rozpoczęciem masażu.",
      "nextStepsDescription_other": "Po złożeniu rezerwacji, przypiszemy jednego z naszych pracowników, dostępnego w Twojej okolicy. Poznasz go w aplikacji przed rozpoczęciem usługi.",
      "pay_blik": "Zapłać za pomocą BLIK",
      "pay_przelewy24": "Zapłać za pomocą Przelewy24",
      "payNow": "Płatność teraz",
      "payNowDescription": "Pamiętaj, że w przypadku regularnego sprzątania, poprosimy Cię o dodanie karty do regularnych sprzątań. Wciąż jednak możesz opłacić swoje pierwsze sprzątanie za pomocą BLIK lub Przelewy24. Niestety, nie przyjmujemy płatności gotówką.",
      "SMSInfo": "Wyślemy kod sms na podany numer telefonu. Wprowadź go, aby potwierdzić logowanie lub rejestrację.",
      "startDate": "Data rozpoczęcia",
      "title": "Podsumowanie",
      "total": "Do zapłaty",
      "VATInvoice": "Dane do faktury",
      "VATInvoiceInfo": "Dane do faktury możesz dodać na dole zamówienia. Pamiętaj, aby zrobić to <b> przed złożeniem zamówienia </b>.",
      "wantToGetVATInvoice": "Chcę otrzymać fakturę VAT",
      "yourStepappWallet": "Twój portfel Stepapp"
    }
  },
  "screens": {
    "accommodation": {
      "description": "Potrzebujemy znać rodzaj Twojego mieszkania, aby zapewnić najlepsze doświadczenie w Stepapp",
      "title": "Gdzie mieszkasz?",
      "type_APARTMENT": "W bloku",
      "type_HOUSE": "W domu"
    },
    "appUpdate": {
      "description": "Właśnie wprowadziliśmy nową, długo oczekiwaną aktualizacje naszego systemu oraz aplikacji. Pojawiło się dużo zmian, ale poniżej przedstawiamy te najważniejsze:",
      "feature1": "[Nowe] Możliwość edycji rezerwacji z poziomu apki, dodawania nowych usług.",
      "feature2": "[Nowe] Możliwość zmiany terminu z poziomu apki.",
      "feature3": "[Nowe] Inteligentny kalendarz dostępności",
      "feature4": "[Nowe] Płatności Apple Pay/Google Pay.",
      "feature5": "[Nowe] Łatwiejsze zarządzanie płatnosciami.",
      "title": "Hej! Powitaj Stepapp 2.0."
    },
    "auth": {
      "alreadyHaveAccount": "Masz już konto?",
      "iHaveAccount": "Mam już konto",
      "inWhichCity": "W jakim mieście chcesz sprawdzić nasze usługi?",
      "letsStart": "Zaczynamy",
      "logIn": "Zaloguj się",
      "logInWith": "Zaloguj się przez %{provider}",
      "order": "Zamów Usługę",
      "register": "Zarejestruj Się",
      "welcomeMessage": "Pomożemy Ci w domowych obowiązkach, dzięki czemu zyskasz więcej wolnego czasu każdego dnia!",
      "welcomeMessage1": "Pomożemy Ci w domowych obowiązkach,\ndzięki czemu zyskasz ",
      "welcomeMessage2": "więcej wolnego\nczasu",
      "welcomeMessage3": " każdego dnia!",
      "whereDoYouLive": "Gdzie mieszkasz?"
    },
    "bookedServices": {
      "downloadApp": "Pobierz Apkę Stepapp",
      "emptyBookings": "Nie masz żadnych zaplanowanych usług. Zamów usługę w Stepapp i wrzuć swój dom na autopilota!",
      "order": "Zamów Usługę",
      "showCompleted": "Zobacz zakończone",
      "toTrackProgress": ", aby śledzić postępy swoich rezerwacji na bieżąco."
    },
    "calendar": {
      "additionalCardVerification": "Być może Twoja karta wymaga dodatkowej weryfikacji.",
      "cantFindDate": "Nie widzisz dogodnego terminu?",
      "failedCardPayment": "Nie mogliśmy pobrać płatności z Twojej karty",
      "hide": "Schowaj",
      "notRegistered": "Tutaj, jako zarejestrowany użytkownik będziesz mógł zobaczyć swoje przyszłe rezerwacje.",
      "paymentFailed": "Nie udało nam się pobrać płatności",
      "paymentFailedDescription": "Zaktualizuj metodę płatności, aby nie stworzyć sobie zaległości",
      "serviceScheduleInfo": "Wyświetlamy tylko najbliższe zaplanowane terminy. Późniejsze terminy pojawią się po zakończonej usłudze. Jeśli chcesz dokonać zmian w późniejszych terminach,",
      "settlePayment": "Ureguluj płatność",
      "showLaterReservations": "Pokaż późniejsze rezerwacje",
      "title": "Kalendarz",
      "updatePayment": "Zaktualizuj metodę płatności",
      "writeToUs": "napisz do nas."
    },
    "cancelReservation": {
      "addDiscount": "Dodaj do swojego portfela w zakładce “Płatności”, a płatność za następną usługę z tej rezerwacji obniży się o %{discount}",
      "cancelAllScheduledAppointments": "Anulujemy wszystkie zaplanowane terminy z tej subskrypcji.",
      "cancelAppointment": "Anuluj ten termin %{fee}",
      "cancelEntireSubscription": "Anuluj całą subskrypcję %{fee}",
      "cancelReservation": "Anuluj rezerwację",
      "cancelSubscription": "Anuluj subskrypcję %{fee}",
      "cancelSingleReservationInSubscription": "Odwołujesz tylko jeden pojedynczy termin (%{date}). Wygeneruje się kolejny termin zgodnie z częstotliwością Twojej subskrypcji.",
      "cancelSubscriptionWithCost": "Możesz też anulować całą subskrypcję, ale i tak poniesiesz koszt za odwołanie tego terminu.",
      "cancelOrEditReservation": "Możesz odwołać całą rezerwację lub zmienić datę.",
      "confirmCancelReservation": "Odwołaj ten termin %{fee}",
      "confirmCancelSubscription": "Odwołaj subskrypcję %{fee}",
      "dontCancelAppointment": "Nie chcę odwoływać terminu",
      "dontCancelSubscription": "Nie chcę odwoływać subskrypcji",
      "insteadOfPaying": "Zamiast płacić %{fee}, możesz oszczędzić %{discount}!",
      "maybeConsiderResubscribe": "Może rozważysz powrót do subskrypcji?",
      "newAddressDiscount": "Zamów sprzątanie pod nowym adresem ze zniżką.",
      "nextServiceDiscount": "-%{discount} na kolejną usługę",
      "reservationCanceled": "Anulowano rezerwacje.",
      "serviceCancellation": "Odwołanie usługi.",
      "specialOffer": "Przygotowaliśmy dla Ciebie specjalną ofertę.",
      "staySubscribed": "Pozostań w subskrypcji i skorzystaj z oferty",
      "subscriptionCanceled": "Anulowano subskrypcję.",
      "weWantToImprove": "Ciągle chcemy się poprawiać, a Twoja opinia ma znaczenie.",
      "whyCancelReservation": "Dlaczego chcesz anulować rezerwację?",
      "whyCancelSubscription": "Dlaczego chcesz anulować subskrypcję?",
      "cancelCause": {
        "haveBetterOffer": "Mam lepszą ofertę",
        "movingToANewPlace": "Zmieniam miejsce zamieszkania",
        "noLongerNeedTheService": "Nie potrzebuję już usług",
        "other": "Inne",
        "problemWithPlatform": "Mam problem z platformą Stepapp",
        "problemWithWorker": "Mam problem z przypisaną osobą",
        "serviceNotGoodEnough": "Usługa nie spełnia moich oczekiwań"
      }
    },
    "chat": {
      "writeMessage": "Napisz wiadomość"
    },
    "completedServices": {
      "completed": "Zakończone",
      "emptyCompleted": "Nie masz żadnych zakończonych usług. Zamów usługę w Stepapp i wrzuć swój dom na autopilota!",
      "title": "Zakończone Rezerwacje"
    },
    "coupons": {
      "addCoupons": "Dodaj do zamówienia",
      "description": "Masz kod zniżkowy lub kod portfelu stepapp?",
      "emptyCoupons": "Nie masz dostępnych kuponów",
      "giveAndReceiveDiscount": "Daj 40 ZŁ, Odbierz 40 ZŁ",
      "removeCoupons": "Usuń z zamówienia",
      "shareMailSubject": "Stepapp",
      "shareMessage": "Hej! Mam dla Ciebie 40 zł za darmo w Stepapp! %{voucherCode}",
      "title": "Kupony",
      "typeCode": "Wpisz kod",
      "validTo": "Ważne do %{date}",
      "walletFundsDescription": "Środki z portfela będą wykorzystane do opłacenia najbliższej usługi",
      "yourDiscounts": "Twoje zniżki"
    },
    "dashboard": {
      "articlesTitle": "Blog Stepapp",
      "bookNow": "Zamów",
      "chooseCategory": "Wybierz kategorię",
      "chooseCity": "Wybierz miasto",
      "couldntProcessPayment": "Nie mogliśmy pobrać płatności za sprzątanie",
      "hygiene": "Higiena",
      "hygieneDescription": "Mamy ścisłe standardy higieny i zerową tolerancję dla łamania zasad bezpieczeństwa.",
      "insurance": "Ubezpieczenie OC",
      "insuranceDescription": "Każde zamówienie w Stepapp jest objęte ubezpieczeniem OC na kwotę 1 000 000 zł.",
      "liabilityInsurance": "Ubezpieczenie OC na kwotę 1 mln zł",
      "mostPopularServices": "Najpopularniejsze usługi",
      "proposeCity": "Zaproponuj miasto",
      "reliability": "Rzetelność",
      "reliabilityDescription": "Weryfikujemy przeszłość i doświadczenie każdej osoby, która trafia do domów naszych klientów.",
      "reviewsWithRating": "%{reviews} opinii ze średnią %{rating}/5",
      "secureOnlineBooking": "Bezpieczna rezerwacja online",
      "seeAllReviews": "Zobacz wszystkie recenzje",
      "seeMore": "Zobacz więcej",
      "servicesWithName": "Cześć! 👋🏻 Jak możemy dać Ci dzisiaj więcej swobody?",
      "startingPrice": "od %{price} zł",
      "testimonials": "recenzji",
      "title": "Zamów dla",
      "trainedProfessionals": "Tylko przeszkoleni profesjonaliści",
      "yourSafetyPriority": "Twoje bezpieczeństwo to \nnasz priorytet.",
      "verifiedAndTrained": "Sprawdzamy i szkolimy wszystkich profesjonalistów Stepapp"
    },
    "category": {
      "chooseYourService": "Wybierz swoją usługę",
      "contactCustomerSupport": "Skontaktuj się z naszym Działem Obsługi Klienta.",
      "easyOnlineBooking": "Łatwa i szybka rezerwacja online",
      "haveQuestions": "Masz jakieś pytania?",
      "liabilityInsurance": "Ubezpieczenie OC do 1 000 000 zł",
      "otherCategories": "Pozostałe kategorie",
      "trainedProfessionals": "Przeszkoleni profesjonaliści",
      "whatMakesUsDifferent": "Co nas wyróżnia?"
    },
    "detailsForm": {
      "description": "Twoje nazwisko i adres e-mail nie będą widoczne dla innych.",
      "title": "Uzupełnij informacje."
    },
    "dismissBrowser": {
      "goBackToApp": "Wróć do aplikacji."
    },
    "editProfile": {
      "aboutMe": "O mnie",
      "changePhoto": "Zmień Zdjęcie",
      "title": "Edytuj Profil",
      "updateInfo": "Zaktualizuj Informacje"
    },
    "flatSize": {
      "description": "Potrzebujemy znać metraż Twojego mieszkania, aby wyświetlać Ci odpowiednie ceny",
      "title": "Ile m2?",
      "unit": "m2"
    },
    "fullScreenNotification": {
      "reservationButtonTitle": "Zobacz Kalendarz",
      "reservationDescription": "Teraz możesz zobaczyć je w swoim kalendarzu i kontrolować postęp prac.",
      "reservationTitle": "Super! Twoja rezerwacja\nzostała przyjęta."
    },
    "homeDescription": {
      "description": "To, co tutaj wpiszesz zostanie przekazane Twojemu wykonawcy",
      "title": "Dodaj instrukcje"
    },
    "homeEdit": {
      "addAddress": "Dodaj adres",
      "chooseFriendlyName": "Wybierz jakąś przyjazną nazwę, na przykład: “Dom babci Gieni”. Ta nazwa jest widoczna tylko dla Ciebie.",
      "confirmDeleteProperty": "Czy na pewno chcesz usunąć mieszkanie?",
      "deleteProperty": "Usuń mieszkanie",
      "editAddress": "Edytuj adres",
      "exactAddress": "Dokładny Adres",
      "homeType": "Typ Domu",
      "notEditableNote": "Możesz zmienić tylko część danych",
      "postalCode": "Kod Pocztowy",
      "provideInformation": "Podaj dokładne dane adresowe, abyśmy mogli bez przeszkód trafić do Twojego domu.",
      "surface": "Powierzchnia",
      "type_APARTMENT": "Apartament",
      "type_HOUSE": "Dom",
      "whatsImportantNote": "Co jest ważne w Twoim domu, jeśli chodzi o obowiązki domowe?"
    },
    "location": {
      "description": "Sprawdzimy, czy usługi Stepapp są\ndostępne w Twoim regionie",
      "title": "Wpisz swój kod pocztowy"
    },
    "login": {
      "alreadyRegistered": "Masz już konto Stepapp?",
      "and": "oraz",
      "firstTime": "Jesteś u nas pierwszy raz?",
      "logInWithAccount": "lub zaloguj się do swojego konta.",
      "noAccRegister": "Nie masz jeszcze konta Stepapp! Najwyższy czas to uporządkować!",
      "orderFirstService": "Zamów swoją pierwszą usługę",
      "privacyPolicy": "Politykę Prywatności",
      "registerTitle": "Już prawie gotowe!\nZaloguj się lub zarejestruj, aby złożyć zamówienie.",
      "registerYourAccount": "lub zarejestruj nowe konto.",
      "selectingOneOfAbove": "Wybierając jedne z powyższych, akceptujesz nasze",
      "social_apple": "Kontynuuj, używając Apple",
      "social_default": "Kontynuuj z numerem telefonu",
      "social_facebook": "Kontynuuj, używając Facebook",
      "social_google": "Kontynuuj, używając Google",
      "termsOfUse": "Warunki Korzystania",
      "title": "Zaloguj się lub zarejestruj",
      "webRegisterTitle": "Już prawie gotowe! Załóż konto Stepapp lub zaloguj się."
    },
    "maintenance": {
      "maintenanceBreak": "Przerwa techniczna",
      "maintenanceContactInfo": "Jeśli potrzebujesz skontaktować się z naszą obsługą, napisz na czacie na stronie %{landingPageUrl} lub na maila: %{supportEmail}",
      "maintenanceInProgress": "Jesteśmy w trakcie dużej aktualizacji systemu, obecnie nasze aplikacje są niedostępne."
    },
    "myHome": {
      "addInfo": "Dodaj Informacje",
      "addressNote": "Dodaj więcej informacji o swoim domu, abyśmy mogli lepiej dopasować się do Twoich potrzeb",
      "notRegistered": "Tutaj, jako zarejestrowany użytkownik będziesz mógł dodać informacje o swoim domu, abyśmy lepiej zrozumieli Twoje potrzeby.",
      "st": "ul",
      "title": "Moje adresy"
    },
    "notes": {
      "addNoteToOrder": "Dodaj notatkę do zamówienia...",
      "cleaningNotes_cleaning": "Notatki do sprzątania",
      "cleaningNotes_massage": "Uwagi odnośnie masażu",
      "cleaningNotes_other": "Uwagi odnośnie usługi",
      "exampleNote_cleaning": "“W kuchni mam blaty z kamienia”\n”Mam czarne fronty szafek, które bardzo się palcują”",
      "exampleNote_massage": "“Proszę o delikatniejszy masaż pleców”\n”Proszę unikać prawego kolana po operacji”",
      "exampleNote_other": "“Proszę zwrócić szczególną uwagę na ...”",
      "notes": "Notatki",
      "whatWeShouldKnow_cleaning": "Czy jest coś, co powinniśmy wiedzieć, aby spełnić Twoje oczekiwania?",
      "whatWeShouldKnow_massage": "Czy jest coś, co powinnismy wiedzieć przed przystąpieniem do usługi? Np. lista przebytych chorób etc",
      "whatWeShouldKnow_other": "Podaj wszystkie informacje i instrukcje, które pozwolą nam w pomyślnej realizacji usługi"
    },
    "notAvailableLocation": {
      "notAvailableLocationDescription": "Nasze usługi nie są dostępne pod tym adresem. Jeśli chcesz żebyśmy się pojawili - daj nam znać!",
      "notAvailableLocationTtile": "Niestety, nie jesteśmy w tej lokalizacji",
      "proposeCity": "Chcę Stepapp w swojej okolicy",
      "proposeCityTitle": "Chcę Stepapp"
    },
    "notificationsCheck": {
      "description": "Nie przegap informacji o promocjach i ważnych wiadomości dotyczących Twojego sprzątania.",
      "enableNotifications": "Włącz powiadomienia",
      "secondDescription": "Włącz powiadomienia, aby otrzymywać informacje o postępach swojej usługi.",
      "secondTitle": "Nie przegap wiadomości.",
      "title": "Chcesz wiedzieć o zniżkach?"
    },
    "oneTimePasswordForm": {
      "description": "Wpisz kod z SMS, który wysłaliśmy do Ciebie na %{phoneNumber}",
      "sendAgain": "Wyślij ponownie",
      "sendAgainIn": "Wyślij ponownie (%{countdown}s.)",
      "title": "Wprowadź kod z sms"
    },
    "paymentFailed": {
      "description": "Nie mogliśmy pobrać środków do\nopłacenia Twojej subskrypcji. Zaktualizuj\nmetodę płatności lub napisz do nas, jeśli\nchcesz ją zmienić lub anulować ",
      "title": "Płatność nie powiodła się"
    },
    "payments": {
      "cantRemoveCardDescription": "Masz trwające usługi. Aby usunąć kartę, opłać sprzątania lub skontaktuj się z obsługą",
      "cantRemoveCardTitle": "Nie można usunąć karty",
      "credits": "Kredyty",
      "editPaymentInfo": "Metody płatności za konkretne rezerwacje edytujesz w szczegółach danej rezerwacji na ekranie “Moje Rezerwacje”",
      "finalized": "Zakończone",
      "noTransactions": "Brak transakcji",
      "paid": "Opłacone",
      "failed": "Nieudane",
      "savedCards": "Zapisane karty",
      "stepappWallet": "Portfel Stepapp: %{balance}",
      "title": "Metody płatności",
      "transactionHistory": "Historia transakcji"
    },
    "phoneForm": {
      "description_login": "Na który zostało zarejestrowane konto Stepapp",
      "description_register": "Potrzebujemy tego, aby móc umożliwić kontakt w sprawie Twojej rezerwacji.",
      "title": "Podaj swój numer telefonu"
    },
    "pickCity": {
      "changeCity": "Zmień miasto",
      "changeCountry": "Zmień kraj",
      "description": "Stepapp jest obecnie dostępny w miastach podanych poniżej.",
      "loginTitle": "Wybierz miasto, w którym pracujesz.",
      "registerTitle": "Wybierz miasto, w którym będziesz pracować."
    },
    "predefinedProfile": {
      "experienceTitle": "Moje doświadczenie...",
      "lastReviews": "Ostatnie opinie",
      "recommendationsTitle": "O mnie",
      "finishedJobs": "%{count} wykonanych usług",
      "customerReviews": "%{count} opinii klientów",
      "learnMoreVerification": "Dowiedz się więcej o naszym procesie weryfikacji i szkoleń w Stepapp.",
      "readMore": "Przeczytaj więcej",
      "weCareWhoComes": "Dbamy o to, kto przychodzi do Twojego domu.",
      "workerBadgeDescription_training": "%{name} przeszła nasze szkolenie z jakości, zasad pracy i higieny.",
      "workerBadgeDescription_safety": "%{name} została przez nas zweryfikowana i spełnia nasze wymogi bezpieczeństwa.",
      "workerBadgeTitle_training": "Szkolenie",
      "workerBadgeTitle_safety": "Bezpieczeństwo"
    },
    "profile": {
      "removeCard": "Usuń kartę",
      "removeCardExplanation": "Usuwanie karty spowoduje usunięcie jej z Twojego konta. Nie będzie ona już dostępna do płatności.",
      "title": "Twój Profil",
      "totalOrders_zero": "%{count} zleconych prac",
      "totalOrders_one": "%{count} zlecona praca",
      "totalOrders_few": "%{count} zlecone prace",
      "totalOrders_other": "%{count} zleconych prac"
    },
    "redeemCoupon": {
      "add": "Dodaj",
      "creditTitle": "Wpisz kod doładowania",
      "voucherTitle": "Wpisz kod promocyjny"
    },
    "reviews": {
      "noReviews": "Nie udało nam się pobrać opinii. Spróbuj ponownie za chwilę.",
      "numberOfReviews": "Liczba recenzji",
      "onlyVerifiedReviews": "Tylko zweryfikowane opinie",
      "orderCleaning": "Zamów sprzątanie",
      "trueReviews": "Wszystkie nasze oceny zostały wystawione przez prawdziwych klientów po wykonanej usłudze.",
      "star": "Gwiazdka",
      "star_plural": "Gwiazdki",
      "star_many": "Gwiazdek"
    },
    "service": {
      "additionalServices": "Co jeszcze możemy dla Ciebie zrobić?",
      "additionalServicesDescription": "Regularność dodatkowych usług możesz zmieniać po pierwszym zleceniu.",
      "addressExplanationForVerification": "Wpisz adres, aby zweryfikować dostępność naszych usług. Na kolejnych krokach możesz dodać dodatkowe informacje.",
      "autocompleteInfo": "<0>Wpisz pełną nazwę ulicy</0>, aby zweryfikować dostępność naszych usług. Na kolejnych krokach możesz dodać dodatkowe informacje.",
      "averageCleaningTime_cleaning": "Przybliżony czas sprzątania",
      "averageCleaningTime_massage": "Przybliżony czas masażu",
      "averageCleaningTime_other": "Przybliżony czas usługi",
      "averageCleaningTimeDescription": "Jest to szacunkowy czas sprzątania, ponieważ wiemy, że każdy dom jest inny. Jeśli na miejscu okaże się, że będzie potrzeba więcej czasu - uprzednio Cię o tym poinformujemy i poprosimy o akceptację.",
      "backToHome": "Wróć do strony głównej",
      "changeAddress": "Zmień adres",
      "chooseAddress": "Wybierz adres",
      "chooseServiceAdjustedToYourNeeds": "Wybierz usługę dopasowaną do Twoich potrzeb",
      "happyCustomers": "Szczęśliwi klienci",
      "howOften": "Jak często?",
      "howOftenDescription": "Zawsze ta sama, zaufana osoba. Wypróbuj bez okresu wypowiedzenia.",
      "includedInService": "Zawarte w usłudze!",
      "loader": "Jeszcze chwila,\nprzetwarzamy Twoje zamówienie",
      "newAddress": "Nowy adres",
      "nextDataAddress": "Dalej - data i adres",
      "pickOrCreateAddress": "Wybierz adres z zapisanych domów lub dodaj nowy",
      "priceForService": "Cena za usługę",
      "reservationError": "Ups! Coś poszło nie tak",
      "reservationErrorDescription": "Spróbuj ponownie później lub skontaktuj się\nz naszym działem obsługi klienta",
      "reservationSuccess": "Super! Twoja rezerwacja\nzostała potwierdzona",
      "reservationSuccessDescription": "Teraz możesz ją zobaczyć w swoim\nkalendarzu i kontrolować postęp prac.",
      "reviews": "Opinie o Stepapp",
      "seeDetails": "Zobacz szczegóły",
      "seeLastReviews": "Zobacz Ostatnie Opinie",
      "selectAvailableOptions": "Wybierz dostępne opcje, aby zobaczyć szczegóły zamówienia",
      "serviceDateInfo": "Darmowa zmiana daty do %{hours} godzin przed rozpoczęciem Twojej rezerwacji.",
      "serviceInsurance": "Twoje sprzątanie jest ubezpieczone na\nkwotę %{amount}.",
      "serviceProtects": "Rezerwację chroni",
      "serviceRange": "Zakres usługi",
      "showCalendar": "Zobacz kalendarz",
      "showMoreServices": "Więcej dodatkowych usług",
      "subscriptionExplanationForEdit": "Pamiętaj, że regularne sprzątanie możesz później modyfikować",
      "whatKindOfServiceYouNeed": "Jakiej usługi potrzebujesz?",
      "whatServiceIncludes": "Co zawiera usługa?",
      "whichAddress": "Dla jakiego adresu zamawiasz?",
      "whichAddressDescription": "Wybierz jeden z zapisanych adresów lub dodaj nowy."
    },
    "serviceAcceptedOverlay": {
      "thankYou": "Dziękujemy!",
      "reviewSubmitted": "Twoja opinia została pomyślnie przesłana. Każda uwaga pomaga nam ulepszać nasze usługi."
    },
    "serviceCalendar": {
      "chooseHour": "Wybierz godzinę, która Ci pasuje",
      "description": "Wybierz datę i godzinę rozpoczęcia usługi",
      "title": "Kiedy zaczynamy?"
    },
    "serviceCard": {
      "canceled": "Anulowne",
      "details": "Szczegóły",
      "rateAndAccept": "Zaakeptuj i oceń pracę",
      "showProgress": "Sprawdź postępy",
      "today": "Dzisiaj",
      "type_oneTime": "Jednorazowe",
      "type_subscription": "Subskrybcja",
      "worker": "Worker"
    },
    "serviceConfirmation": {
      "completedServicePhoto": "Usługa została wykonana. Zrobiliśmy zdjęcie, które jest weryfikacją naszej obecności na miejscu. Jest widoczne tylko dla Ciebie i naszej obsługi.",
      "doYouAcceptService": "Czy akceptujesz wykonanie usługi?",
      "report": "Zgłoś problem"
    },
    "serviceDetails": {
      "additionalInfo": "Dodatkowe instrukcje dla Wykonawcy",
      "addMoreServices": "Dodaj więcej usług",
      "calendarChangeDateInfo": "Pobierzemy opłatę gdy zmienisz datę jednorazowej usługi, mniej niż %{hoursBeforeFee} godzin przed pierowtnym terminem.",
      "cancellationRule": "Możesz anulować i edytować usługę do %{hoursBeforeFee} godzin przed i uzyskać 100% zwrotu środków. Anulowanie po tym czasie może wiązać się z dodatkowymi opłatami.",
      "cancellationRules": "Zasady Anulowania",
      "cancelService": "Odwołaj tę usługę",
      "changeServiceDetails_cleaning": "Zmień szczegóły sprzątania",
      "changeServiceDetails_massage": "Zmień szczegóły masażu",
      "changeServiceDetails_other": "Zmień szczegóły usługi",
      "changeDate": "Zmień datę %{fee}",
      "changeDate2": "Zmień termin",
      "changeDateInfo": "Możesz zmienić bezpłatnie datę i godzinę wykonania usługi do %{hoursBeforeFee} godzin przed zarezerwowanym terminem.",
      "changeDateIntercomMessage": "Dzień dobry, poproszę o zmianę daty mojej rezerwacji z ... na ...",
      "changeDetails": "Zmiany szczegółów",
      "cantUpdateAdditionalService": "Dodatkowa usługa nie może zostać zaktualizowana.",
      "chat": "Rozpocznij Czat",
      "close": "Zamknij",
      "confirmDeleteService": "Na pewno? Dodatkowa usługa nie zostanie wykonana",
      "currentPrice": "Obecna cena",
      "deleteService": "Usunąć %{service}?",
      "fee": "(opłata %{fee})",
      "fetchReservationError": "Coś poszło nie tak podczas pobierania szczegółów Twojej rezerwacji. Wróć na kalendarz rezerwacji i spróbuj raz jeszcze. Jeśli problem będzie występować dalej - skontaktuj się z nami.",
      "hour": "Godzina",
      "hours": "Godziny",
      "manage": "Zarządzaj",
      "newPrice": "Nowa cena",
      "orderFor": "Zamówienie dla:",
      "paymentForm": "Forma płatności",
      "questionNotFound": "Nie udało się znaleźć pytania do aktualizacji",
      "questionCantBeUpdated": "Przepraszamy, ale tej odpowiedzi nie można już modyfikowac. W celu zmian skontaktuj sie z obsługą klienta.",
      "service": "Usługa",
      "showCancellationRules": "Zobacz Nasze Zasady Anulowania",
      "submitChangeConfirmation": "Termin usługi został zapisany!",
      "submitChangeLoader": "Jeszcze chwila, zapisujemy zmiany",
      "submitDetailsConfirmation": "Zmiany w usłudze zostały zapisane!",
      "subscriptionChangeDateInfo": "Subskrybenci mają elastycznie! Dla sprzątania w ramach subskrypcji zmiany wprowadzisz bezpłatnie do 36 godzin przed usługą!",
      "total": "Łącznie",
      "totalPaymentInfo": "Płatność pobierzemy dopiero w dniu sprzątania, ale środki zablokujemy 48h przed terminem.",
      "type_oneTime": "Jednorazowe",
      "type_subscription": "Subskrybcja",
      "writeToUs": "napisz do nas"
    },
    "serviceRating": {
      "addPublicReview": "Dodaj publiczną opinię",
      "answersNotShared": "Odpowiedzi nie zostaną udostępnione wykonawcy.",
      "asYourWorker": "jako swojego wykonawcę?",
      "cleanLeaveRating": "Czysto? Oceń pracę!",
      "doYouWantToKeep": "Czy chcesz zatrzymać",
      "enterText": "Wpisz tekst",
      "followedInstructions": "Czy stosował się do Twoich zaleceń?",
      "giveYouComment": "Przekaż nam swoje uwagi",
      "howDoYouRateYourExperience": "Jak oceniasz swoje doświadczenia?",
      "keep": "Zatrzymaj",
      "leaveOpinion": "Wystaw opinię",
      "leaveOpinionAndRating": "Podziel się opinią i oceń usługę.",
      "leaveRating": "Wystaw ocenę",
      "newWorker_description": "Nowego wykonawcę zobaczysz 48 godziny przed następną usługą",
      "newWorker_title": "OK, do następnej usługi przydzielimy kogoś innego",
      "optional": "Opcjonalnie",
      "rating1": "Fatalna jakość usługi",
      "rating2": "Słabo",
      "rating3": "Usługa nie spełniła moich oczekiwań",
      "rating4": "Było OK, ale wymaga poprawy",
      "rating5": "Usługa spełniła moje oczekiwania w 100%",
      "sorryToHearThat": "Przykro nam to słyszeć.",
      "touchStarsToLeaveReview": "Dotknij gwiazdek, aby wystawić opinię.",
      "wasOnTime": "Czy wykonawca był na czas?",
      "wasPrepared": "Czy wykonawca był odpowiednio przygotowany do pracy?",
      "wantTheSameWorkerAgain": "Czy chciałbyś, żeby ten wykonawca ponownie do Ciebie przyszedł?"
    },
    "serviceRealization": {
      "chat": "Czat",
      "checkAndConfirm": "Sprawdź i zaakceptuj efekty",
      "daysLeft": "%{daysLeft} dzień",
      "daysLeft_plural": "%{daysLeft} dni",
      "info": "Info",
      "rateTheServiceWithin": "Oceń usługę do 7 dni",
      "report": "Zgłoś",
      "serviceCompleted": "Usługa wykonana!",
      "serviceStatus": "Status usługi",
      "statusChoosen": "Workerka przypisana",
      "statusChoosenDescription": "Dobraliśmy osobę która wykona usługę w Twoim domu! Dla usług w ramach subskrypcji zawsze bedzie to ta sama osoba!",
      "statusInProgress": "W trakcie usługi",
      "statusInProgressDescription": "Workerka już pracuje nad porządkami! Gdy sprzątanie się zakończy, poprosimy Cię o opinie!",
      "statusOnTheWay": "Workerka jest w drodze",
      "statusOnTheWayDescription": "To już dziś! Niedługo workerka przybędzie odświeżyć Twój dom!",
      "statusWaitingForAccpetance": "Twoje zamówienie zostało wykonane!",
      "still": "jeszcze"
    },
    "serviceSummary": {
      "addCreditDebitCard": "Dodaj Kartę Płatniczą",
      "additionalServices": "Dodatkowe usługi",
      "cardPayment": "Płatność kartą",
      "changeCoupon": "Zmień kupon",
      "changeDate": "Zmień datę",
      "confirmAndOrder": "Potwierdź i Zapłać",
      "choosePaymentMethod": "Wybierz formę płatności",
      "coupon": "Kupon \"%{coupon}\"",
      "description": "Przejrzyj swoje zamówienie jeszcze raz i sprawdź, czy wszystko się zgadza",
      "enterCoupon": "Wprowadź kupon",
      "frequency_EVERY_MONTH": "Co miesiąc",
      "frequency_EVERY_TWO_WEEKS": "Co dwa tygodnie",
      "frequency_EVERY_WEEK": "Co tydzień",
      "frequency_ONE_TIME": "Jednorazowo",
      "grossPriceIncludingVAT": "Cena powyżej jest ceną brutto zawierającą podatek VAT %{vat}%",
      "howOften": "Jak często?",
      "importantInformation": "Ważne informacje",
      "iWillBeThere": "Będę na miejscu",
      "logIn": "Zaloguj się",
      "loginToViewDetails": "Zaloguj się lub zarejestruj, aby złożyć zamówienie",
      "orderingFor": "Zamawiasz dla",
      "orderingForDescription": "Podane informacje będą zapisane w profilu jako “Mój adres”",
      "paidOnServiceDay": "Pobranie w dniu realizacji",
      "paymentMethod": "Sposób Płatności",
      "paymentNotice": "Po złożeniu zamówienia wykonamy płatność weryfikacyjną w wysokości ceny zamówienia. Zostanie ona zwrócona maksymalnie do 10 minut. Właściwą opłatę za rezerwację pobieramy dopiero po zakończeniu usługi.",
      "paymentNow": "Płatność teraz",
      "paymentNowInfo": "W przypadku rezerwacji z terminem realizacji w ciągu 48 godzin, środki blokujemy w momencie złożenia rezerwacji.",
      "paymentTerms": "Regulamin płatności dostępny na %{link}",
      "recurringPayment": "Kolejne płatności",
      "registerAndOrder": "Zarejestruj się i złóż zamówienie",
      "sendSMSCode": "Wyślij kod SMS'em",
      "SMSInfo": "Wyślemy kod sms na podany numer telefonu. Wprowadź go, aby potwierdzić logowanie lub rejestrację.",
      "subscriptionDiscount": "Zniżka za subskrypcję",
      "title": "Podsumowanie",
      "toPay": "Do zapłaty",
      "total": "Łącznie",
      "usedVoucher": "Użyty kupon",
      "wantEnterCoupon": "Chcesz dodać kupon?",
      "webCardModalTitle": "To już ostatni krok. Dodaj kartę i ciesz się czystym domem. 🏠",
      "webPaymentInfo": "Administratorem Twoich Danych Osobowych jest Stepapp Sp. z.o.o. Administratorem płatności jest Stripe. Nigdy nie pobierzemy środków bez Twojej uprzedniej zgody, a na wszystkie transakcje przysługuje Ci 7-dniowy termin reklamacji.",
      "whatIfSomethingsGoesWrong": "Co jeśli coś pójdzie nie tak?",
      "whatIfSomethingsGoesWrongDescription": "Jeśli nie będziesz zadowolony z usługi, zapewniamy, że zostanie ona ponownie wykonana przez najbardziej doświadczone osoby w naszym zespole. Oczywiście nieodpłatnie.",
      "whatNow": "Co teraz?",
      "whatNowDescription": "Po potwierdzeniu Twojego zlecenia, dopasujemy najlepszego wykonawcę w okolicy na podstawie Twoich preferencji. Poznasz go i będziesz mógł się z nim skontaktować 48 godzin przed rozpoczęciem zlecenia.",
      "when": "Kiedy?",
      "yourCardWillBeLinkedTo": "Twoja karta zostanie przypisana do Twojego konta Stepapp i użyta do kolejnych pobrań zamówionych usług. Zawsze możesz ją zmienić w ustawieniach.",
      "yourDataIsSecureThanksTo": "Twoje dane są bezpieczne dzięki",
      "yourDataIsSecureThanksToStripe": "Twoje dane są bezpieczne dzięki Stripe Ltd.",
      "yourStepappWallet": "Twój Portfel Stepapp "
    },
    "settings": {
      "accountDeleted": "Rozpoczęto procedurę usuwania konta. Musimy sprawdzić, czy nie masz żadnych zaległych transakcji. Twoje konto i wszystkie powiązane dane zostaną usunięte w ciągu 7 dni.",
      "cancellationRules": "Zasady Anulowania",
      "deleteAccount": "Usuń konto",
      "discountsAndPromotions": "Np. zniżki, rabaty i oferty specjalne",
      "email": "Adres Email",
      "logOut": "Wyloguj się",
      "notifications": "Powiadomienia",
      "newsletterAndPromotions": "Newsletter i Promocje",
      "others": "Inne",
      "phoneNumber": "Numer Telefonu",
      "privacyPolicy": "Polityka Prywatności",
      "pushNotifications": "Powiadomienia w aplikacji",
      "informationAboutReservation": "M.in.: informacje o Twoich rezerwacjach, wiadomości od obsługi klienta",
      "reminderAboutReservation": "M.in.: przypomnienia o rezerwacjach, pilne wiadomości od obsługi klienta",
      "removeAccountExplanation": "Twoje konto zostanie usunięte. Tej czynności nie można cofnąć.",
      "smsNotifications": "Powiadomienia SMS",
      "title": "Ustawienia",
      "updateEmailAddress": "Zaktualizuj adres email",
      "wantToChangePhoneNumber": "Jeśli chcesz zmienić numer telefonu,"
    },
    "support": {
      "call": "Zadzwoń",
      "contactOptions": "Opcje kontaktu:",
      "sendEmail": "Wyślij mail",
      "startChat": "Rozpocznij Czat",
      "title": "Skontakuj się z nami"
    },
    "unmatched": {
      "description": "Nie możemy odnaleźć strony, której szukasz. Spróbuj wrócić do poprzedniej strony lub skontaktuj się z nami w celu uzyskania dodatkowych informacji.",
      "title": "Oops,\nnic tu nie ma..."
    },
    "welcome": {
      "customerSupportDescription": "Jesteśmy dostępni dla Ciebie 7 dni w tygodniu przez chat oraz email i odpowiemy na każdy problem, którego nie rozwiążesz przez aplikację.",
      "customerSupportTitle": "Obsługa klienta zawsze dostępna.",
      "letsStart": "Zaczynamy!",
      "orderCleaningDescription": "Wyceń sprzątanie swojego domu, wybierz dostępny termin i zamów usługę o dowolnej porze, 24/7.",
      "orderCleaningTitle": "Łatwy i szybki sposób na zamówienie sprzątania.",
      "trustedTeamDescription": "Każda osoba sprzątająca w Stepapp została sprawdzona podczas kilkudniowego szkolenia i sprząta według określonych zasad i standardów.",
      "trustedTeamTitle": "Zaufany, doświadczony i przeszkolony zespół."
    }
  },
  "validation": {
    "address": "Podaj poprawny adres",
    "blank": "Pole nie może być puste",
    "city": "Podaj poprawną nazwę miasta",
    "companyName": "Podaj nazwę firmy",
    "date": "Wybierz datę usługi",
    "email": "Podaj poprawny adres e-mail",
    "firstName": "Podaj swoje imię",
    "homeType": "Wybierz typ domu",
    "hour": "Wybierz godzinę usługi",
    "invalid": "Podaj poprawne dane",
    "keyInfo": "Opisz gdzie zostawisz klucz",
    "lastName": "Podaj swoje nazwisko",
    "maxSurface": "Maksymalna obsługiwana powierzchnia to %{maxSize}m2",
    "minSurface": "Minimalna obsługiwana powierzchnia to %{minSize}m2",
    "nipNumber": "Podaj poprawny kod NIP",
    "numberOrHousing": "Podaj numer mieszkania/domu",
    "phone": "Podaj poprawny numer telefonu",
    "pickAddress": "Wybierz adres",
    "pickOption": "Wybierz jedną z opcji",
    "postalCode": "Podaj poprawny kod pocztowy",
    "required": "Wymagane",
    "smsOrPhoneNumber": "Błędny kod SMS lub numer telefonu"
  },
  "verification": {
    "closePage": "Ta strona zamknie się automatycznie po 10 sekundach",
    "paymentVerificationConfirmed": "Twoja płatność została potwierdzona",
    "paymentVerificationFailed": "Potwierdzenie nie powiodło się",
    "retryVerification": "Spróbuj ponownie lub użyj innej metody płatności."
  }
}
